export const SEARCH_INDEX_NAME_BASE = 'petitions_';
export const SEARCH_PRESET_BASE = 'petitions_initial_';

export const SEARCH_VECTOR_INDEX_NAME_BASE = 'petitions_vectors_';
export const SEARCH_VECTOR_PRESET_BASE = 'petitions_vectors_initial_';
// Languages with a vector collection, alias and preset in Typesense (mirrors the search ingester's
// `embedding_locales`). The search_use_vector_collection FCM is ignored for any other language.
export const SEARCH_VECTOR_COLLECTION_LANGUAGES: readonly string[] = ['en'];

export const SEARCH_LOCATION_CITY_FILTER = 'location.city_state';
export const SEARCH_LOCATION_COUNTRY_CODE_FILTER = 'location.country_code';
export const SEARCH_LOCATION_FILTER_MAX_ITEMS = 4;
export const SEARCH_LOCATION_SUGGESTIONS_MAX_ITEMS = 6;
export const SEARCH_LOCATION_SUGGESTIONS_MAX_COUNTRIES = 3;
// the locations collection has one doc per site DB row, so many docs per place: we group them and fetch enough groups to rank
export const SEARCH_LOCATION_CITY_MAX_GROUPS = 20;
export const TYPESENSE_LOCATION_FILTER = 'city';
export const TYPESENSE_LOCATION_COLLECTION = 'locations';

export const SEARCH_CACHE_SECONDS = 2 * 60;

export const SEARCH_DECISION_MAKERS_INDEX_NAME = 'decision_makers';
// once the petitions arrive, how much longer they wait for the decision maker lookup; past that they render without the card
export const SEARCH_DECISION_MAKER_GRACE_MS = 150;
// a query's lookup result is reused across filter, sort and page changes
export const SEARCH_DECISION_MAKER_STALE_TIME_MS = 10 * 60_000;
// Typesense synonym set with one-way nickname synonyms ("greg" -> "gregory"), managed through the Typesense API
export const SEARCH_DECISION_MAKER_SYNONYM_SET = 'dm-nicknames';
// the same decision makers the DM autocomplete suggests: keep in sync with DECISION_MAKERS_FILTER_BY in
// apps/middle-end/src/shared/typesense/decisionMakers/decisionMakerSearch.ts (CHANGE-101320 moves both into a preset).
// The OR group must come first: this query goes through the public /ts proxy, whose firewall blocks "&& (… || …)"
// with a 403 (the middle-end's server-side query doesn't pass through it).
export const SEARCH_DECISION_MAKERS_FILTER_BY = '(is_confirmed:=true || verified_at:>0) && discoverable:=true';

/**
 * When a query names a decision maker. Kept in one object so it can later move to a JSON FCM.
 */
export const SEARCH_DECISION_MAKER_MATCHING = {
	// a common name can match someone nobody petitions, so the card needs some petitions behind it
	minPetitions: 10,
	// how many top hits to compare (also how many namesakes the lead rules can see)
	candidates: 10,
	maxQueryWords: 5,
	fullName: {
		minLeadRatio: 3,
	},
	// a surname alone ("trump") only shows a well-known decision maker who clearly stands out
	surnameOnly: {
		// a single word is ambiguous, so it only names officials (Politician) and offices (Role: "Illinois Governor",
		// Group: "U.S. Senate"), not brands or other "Custom" records ("union", "apple")
		targetableTypes: ['Politician', 'Role', 'Group'],
		maxNameWords: 3,
		// with the verified and 10x-lead rules, 100 lets current officeholders like "mamdani" or "ossoff" through
		minPetitions: 100,
		requireVerified: true,
		minLeadRatio: 10,
	},
} as const;
